class AppConfig {
  getOldAppBaseUrl(): string {
    return AppConfig.cleanUrl(process.env.VUE_APP_OLD_BASE_URL);
  }

  getAuthServiceUrl(): string {
    return AppConfig.cleanUrl(process.env.VUE_APP_AUTH_BASE_URL);
  }

  getAPIBaseUrl(): string {
    return AppConfig.cleanUrl(process.env.VUE_APP_API_BASE_URL);
  }

  getGeoIpServiceBaseUrl(): string {
    return AppConfig.cleanUrl(process.env.VUE_APP_GEOIP_SERVICE_BASE_URL);
  }

  getIntercomAppId(): string {
    return process.env.VUE_APP_INTERCOM_APP_ID || '';
  }

  getIntercomSecret(): string {
    return process.env.VUE_APP_INTERCOM_SECRET_KEY || '';
  }

  getSnowplowCollectorEndpoint(): string {
    return process.env.VUE_APP_SNOWPLOW_ENDPOINT ?? '';
  }

  getCustomerIoWriteKey(): string {
    return process.env.VUE_APP_CUSTOMERIO_WRITE_KEY ?? '';
  }

  // Region-specific CDN for the Customer.io SDK. Empty falls back to the SDK default (US).
  getCustomerIoCdnUrl(): string {
    return AppConfig.cleanUrl(process.env.VUE_APP_CUSTOMERIO_CDN_URL);
  }

  // Workspace site id. The SDK loads the in-app plugin only when it has one.
  getCustomerIoSiteId(): string {
    return process.env.VUE_APP_CUSTOMERIO_SITE_ID ?? '';
  }

  getAppUrl(): string {
    return AppConfig.cleanUrl(process.env.VUE_APP_URL);
  }

  getOptimizelySdkKey(): string {
    return process.env.VUE_APP_OPTIMIZELY_SDK_KEY ?? '';
  }

  getOptimizelyDatafileUrl(): string {
    return process.env.VUE_APP_OPTIMIZELY_DATAFILE_URL ?? '';
  }

  getPromoCodeId(): string {
    return process.env.VUE_APP_PROMO_CODE_ID ?? '';
  }

  getStripeKeyUS(): string {
    return process.env.VUE_APP_STRIPE_KEY_US ?? '';
  }

  getDefaultStripeKey(): string {
    // StripeKeyEU
    return process.env.VUE_APP_STRIPE_KEY_DEFAULT ?? '';
  }

  // Cancelled subscriptions promo code
  getCNV3263PromoCodeId(): string {
    return process.env.VUE_APP_CNV_3263_PROMO_CODE_ID ?? '';
  }

  private static cleanUrl(url: string | undefined): string {
    if (url) {
      return url.replace(/\/$/, '');
    }
    return '';
  }
}

export default new AppConfig();
